import API from "../services/api";
import StorageService from '../services/general/storage';
const attribute = "settings";

const SettingsService = {
  get: () => {
    return new Promise((resolve, reject) => {
      API.get(attribute ).then(
        result => {
          resolve(result);
          StorageService.setCollectionObject(attribute, null, result);
        },
        error => {
          StorageService.getCollectionObject(attribute, null).then((foundStorage) => {
            resolve(foundStorage);
          }, (err) => {
            reject(err);
          })
        }
      );
    });
  },

  save: item => {
    return new Promise((resolve, reject) => {
      if (item._id) {
        API.post(attribute + "/" + item._id, [], item).then(
          result => {
            resolve(result);
          },
          error => {
            reject(error);
          }
        );
      } else {
        API.put(attribute, [], item).then(
          result => {
            resolve(result);
          },
          error => {
            reject(error);
          }
        );
      }
    });
  }
};

export default SettingsService;
